import { useState } from 'react';
import { InfoOutlined, LockOutlined, NextPlanOutlined, UploadFileOutlined } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import { useTranslation } from 'react-i18next';
import colors from '../../../../scss/colors';
import CVUploader from '../../../../Components/common/CVUploader/CVUploader';
import MainButton from '../../../../Components/common/buttons/MainButton';
import { buttonVariants } from '../../../../Components/common/buttons/types';

export default function ProfileBuilder({
  anchor = 'bottom',
  isOpen,
  onFilesSelected = () => {},
  onSkip = () => {},
  onExtract = () => {},
  onUploadCvMobile = () => {}
}) {
  const { t } = useTranslation();

  const [files, setFiles] = useState([]);

  const handleFilesSelected = (selectedFiles) => {
    setFiles(selectedFiles);
    onFilesSelected(selectedFiles);
  };
  return (
    <Drawer
      anchor={anchor}
      open={isOpen}
      sx={{
        zIndex: 9999
      }}
    >
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-start justify-between h-full p-6">
        <div className="flex flex-col gap-3 w-full md:w-1/2">
          <p className="text-lg md:text-2xl font-medium text-navy-blue">{t('dashboard.profile.build')}</p>
          <p className="text-sm md:text-base text-gray-800">{t('dashboard.profile.build_detail')}</p>
          <ul className="list-disc text-sm md:text-base text-gray-800 ml-5">
            <li>{t('dashboard.profile.benefit_1')}</li>
            <li>{t('dashboard.profile.benefit_2')}</li>
            <li>{t('dashboard.profile.benefit_3')}</li>
          </ul>
          <div className="flex items-start gap-2">
            <InfoOutlined sx={{ fontSize: '30px', color: colors.LIGHT_BLUE }} />
            <p className="text-xs md:text-sm text-gray-500">{t('dashboard.profile.info')}</p>
          </div>
        </div>
        <div className="w-px bg-stone-200 self-stretch mr-8" />
        <div className="flex flex-col gap-3 w-full md:w-1/2">
          <CVUploader
            onFilesSelected={(selectedFiles) => handleFilesSelected(selectedFiles)}
            onUpload={onUploadCvMobile}
          />
          <div className="flex items-center gap-2">
            <LockOutlined sx={{ fontSize: 34, color: colors.LIGHT_BLUE, pt: 0.5 }} />
            <p className="text-xs md:text-sm text-gray-500">{t('dashboard.profile.cvPrivacyInfo')}</p>
          </div>
          <div className="flex flex-row justify-center md:justify-between items-center">
            <div className="flex flex-col items-center text-center md:text-left md:items-start">
              <MainButton
                variant={buttonVariants.TEXTBLUE}
                sx={{
                  color: colors.NAVY_BLUE,
                  gap: '10px',
                  padding: 0,
                  border: 0
                }}
                action={onSkip}
              >
                {t('dashboard.profile.skipButton')}
                <NextPlanOutlined />
              </MainButton>
              <p className="text-sm text-gray-500">{t('dashboard.profile.skipInfo')}</p>
            </div>
            <div className="hidden md:flex flex-col">
              <MainButton
                variant={!files.length ? buttonVariants.DISABLED : buttonVariants.SECONDARY}
                rounded
                disabled={!files.length}
                size="xmedium"
                action={onExtract}
                sx={{
                  gap: '10px'
                }}
              >
                <UploadFileOutlined />
                {t('common.general.extract')}
              </MainButton>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
